import type {InviteApiModel} from '../../../../api/invite';
import type {MembershipApiModel} from '../../../../api/membership';
import type {Invite} from '../types';

import {getEntityTypeById} from '../../../../utils/entity/getEntityType';
import {DeleteProposedMembershipStrategy} from './DeleteProposedMembershipStrategy';
import {DeleteRegularInviteStrategy} from './DeleteRegularInviteStrategy';

export class DeleteInviteStrategyFactory {
  static createStrategy(invite: Invite) {
    const type = getEntityTypeById(invite._id);

    switch (type) {
      case 'invite':
        return new DeleteRegularInviteStrategy(invite as InviteApiModel);
      case 'membership':
        return new DeleteProposedMembershipStrategy(
          invite as MembershipApiModel,
        );
      default:
        throw new Error(`Unknown invite target entity type: ${type}`);
    }
  }
}
